export const localization = {
	"kz":{
        Alert: {
            addData: "Деректеріңізді енгізіңіз",
            addCV: "Резюмеңізді жүктеу",
            addPersonalInfo: "Жеке деректеріңізді енгізіңіз",
            writeTask: "Тапсырмаңызды немесе жобаны енгізіңіз",
            addDescription: "Жұмыс сипаттамасын енгізіңіз"
        },
        StudentOrRecruiter: {
            role: "Сіздің рөліңіз",
            student: "Мен студентпін",
            recruiter: "Мен рекрутермін"
        },
        CareerPlan: {
            title: "Карьералық жоспар құру",
            major: "Сіздің мамандығыңыз",
            yearOfStudy: "Сіз қай курста оқисыз?",
            dreamJob: "Арман жұмыс",
            dreamProject: "Арман жоба",
            goal: "Сіздің басты карьералық мақсатыңыз қандай?",
            write: "Жазыңыз",
            pdf: "PDF файлды жүктеу үшін басыныз немесе әкеліп салыныз",
            Buttons: {
                back: "Артқа",
                continue: "Жалғастыру"
            }
        },
        JobDescription: {
            title: "Жұмыс сипаттамасын жасау",
            wantGenerate: "Мен жұмыс сипаттамасын неге негізделіп жасағым келеді",
            task: "Тапсырма",
            project: "Жоба",
            describe: "Тапсырманы/жобаны сипаттаңыз",
            Buttons: {
                back: "Артқа",
                continue: "Жалғастыру",
                search: "Іздеу",
                haveDesc: "Менде жұмыс сипаттамасы бар",
            }
        },
        CandidateSearch: {
            title: "Мамандарды іздеу",
            findCandidate: "Жұмыс сипаттамасына сәйкес келетің мамандарды іздеу",
            description: "Жұмыс сипаттамасы",
            Buttons: {
                back: "Артқа",
                search: "Жалғастыру"
            }
        },
        Output: {
            seconds: "Бір минут...",
            yourPlan: "Сіздің жоспарыңыз",
            jobDescription: "Жұмыс сипаттамасы",
            suitableCandidates: "Жұмыс сипаттамасына сәйкес келетін мамандар",
            Buttons: {
                search: "Іздеу",
                copy: "Көшіру",
                copied: "Көшірілді",
                back: "Артқа"
            }
        }
    },
	"ru":{
        Alert:{
            addData: "Введите ваши данные",
            addCV: "Загрузите ваше резюме",
            addPersonalInfo: "Введите свои личные данные",
            writeTask: "Введите вашу задачу или ваш проект",
            addDescription: "Введите описание работы",
        },
        StudentOrRecruiter:{
            role: "Ваша роль",
            student: "Я студент",
            recruiter: "Я рекрутер",
        },
        CareerPlan:{
            title: "Сгенерировать карьерный план",
            major: "Ваша специальность",
            yearOfStudy: "На каком вы курсе?",
            dreamJob: "Работа мечты",
            dreamProject: "Проект мечты",
            goal: "Какова ваша главная карьерная цель?",
            write: "Напишите",
            pdf: "Нажмите или перетащите чтобы загрузить PDF файл",
            Buttons:{
                back: "Назад",
                continue: "Продолжить",
            }
        },
        JobDescription:{
            title: "Сгенерировать описание работы",
            wantGenerate: "Я хочу сгенерировать описание работы с помощью",
            task: "Задача",
            project: "Проект",
            describe: "Опишите вашу задачу/проект",
            Buttons: {
                back: "Назад",
                continue: "Продолжить",
                search: "Поиск",
                haveDesc: "У меня уже есть описание",
            }
        },
        CandidateSearch:{
            title: "Поиск кандидатов",
            findCandidate: "Найти подходящих кандидатов по описанию работу",
            description : "Описание работы",
            Buttons: {
                back: "Назад",
                search: "Продолжить",
            }
        },
        Output:{
            seconds: "Секундочку...",
            yourPlan: "Ваш план",
            jobDescription: "Описание работы",
            suitableCandidates: "Подходящие кандидаты",
            Buttons: {
                search: "Поиск",
                copy: "Копировать",
                copied: "Скопировано",
                back: "Назад",
            }
        },
    },
	"en":{
        Alert: {
            addData: "Enter your data",
            addCV: "Upload your resume",
            addPersonalInfo: "Enter your personal information",
            writeTask: "Enter your task or project",
            addDescription: "Enter job description"
        },
        StudentOrRecruiter: {
            role: "Your role",
            student: "I'm a student",
            recruiter: "I'm a recruiter"
        },
        CareerPlan: {
            title: "Generate a career plan",
            major: "Your major",
            yearOfStudy: "Year of study?",
            dreamJob: "Dream job",
            dreamProject: "Dream project",
            goal: "What is your main career goal?",
            write: "Type in",
            pdf: "Click or drag and drop to upload a PDF file",
            Buttons: {
                back: "Back",
                continue: "Continue"
            }
        },
        JobDescription: {
            title: "Generate a job description",
            wantGenerate: "I want to generate a job description using",
            task: "Task",
            project: "Project",
            describe: "Describe your task/project",
            Buttons: {
                back: "Back",
                continue: "Continue",
                search: "Search",
                haveDesc: "I already have a description",
            }
        },
        CandidateSearch: {
            title: "Candidate Search",
            findCandidate: "Find suitable candidates based on job description",
            description: "Job description",
            Buttons: {
                back: "Back",
                search: "Continue"
            }
        },
        Output: {
            seconds: "Just a moment...",
            yourPlan: "Your plan",
            jobDescription: "Job description",
            suitableCandidates: "Suitable candidates",
            Buttons: {
                search: "Search",
                copy: "Copy",
                copied: "Copied",
                back: "Back"
            }
        }
    }
      
}